import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { NativeSelect } from "@/components/common";
import { notaPreview } from "@/lib/format";

const EMPTY = { name: "", address: "", phone: "", email: "", nota_code: "", extra_code: "", notas_per_page: 8, reserve_pct: 30, round_multiple: 5, nota_footer: "", app_name: "" };
const PER_PAGE = [4, 6, 8, 10, 12];

const Field = ({ label, hint, children }) => (
  <div>
    <Label className="text-xs font-semibold text-slate-700">{label}</Label>
    <div className="mt-1">{children}</div>
    {hint && <p className="text-[11px] text-slate-500 mt-1">{hint}</p>}
  </div>
);

export function CompanyForm({ initial, onSubmit, disabled, submitLabel = "Simpan", children }) {
  const [f, setF] = useState(EMPTY);
  useEffect(() => {
    setF({ ...EMPTY, ...(initial || {}) });
  }, [initial]);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const submit = (e) => {
    e.preventDefault();
    const { name, address, phone, email, nota_code, extra_code, nota_footer, app_name } = f;
    onSubmit({ name, address, phone, email, nota_code, extra_code, nota_footer, app_name: app_name || "",
      notas_per_page: Number(f.notas_per_page), reserve_pct: Number(f.reserve_pct), round_multiple: Number(f.round_multiple) });
  };
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="company-form">
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Nama Perusahaan"><Input value={f.name} onChange={set("name")} disabled={disabled} required data-testid="company-name-input" /></Field>
        <Field label="Email"><Input value={f.email || ""} onChange={set("email")} disabled={disabled} data-testid="company-email-input" /></Field>
        <Field label="Nama Aplikasi (opsional)" hint="Tampil di sidebar & judul tab setelah login. Kosongkan untuk memakai nama dari Admin Utama."><Input maxLength={60} value={f.app_name || ""} onChange={set("app_name")} disabled={disabled} placeholder="mis. AFLINK Billing" data-testid="company-app-name-input" /></Field>
        <Field label="Alamat Kantor"><Input value={f.address || ""} onChange={set("address")} disabled={disabled} data-testid="company-address-input" /></Field>
        <Field label="Kontak / Telepon"><Input value={f.phone || ""} onChange={set("phone")} disabled={disabled} data-testid="company-phone-input" /></Field>
      </div>
      <div className="border border-emerald-200 bg-emerald-50/50 rounded-sm p-4 grid sm:grid-cols-3 gap-4">
        <Field label="Kode Nota (2 huruf)"><Input maxLength={2} value={f.nota_code} onChange={set("nota_code")} disabled={disabled} required className="font-mono uppercase" data-testid="company-nota-code-input" /></Field>
        <Field label="Kode Tambahan (opsional)" hint="Maks. 4 huruf/angka"><Input maxLength={4} value={f.extra_code || ""} onChange={set("extra_code")} disabled={disabled} className="font-mono uppercase" data-testid="company-extra-code-input" /></Field>
        <Field label="Contoh Nomor Nota"><div className="h-9 flex items-center font-mono font-semibold text-emerald-800" data-testid="nota-number-preview">{notaPreview(f.nota_code, f.extra_code)}</div></Field>
      </div>
      <div className="grid sm:grid-cols-3 gap-4">
        <Field label="Nota per Halaman A4">
          <NativeSelect value={f.notas_per_page} onChange={set("notas_per_page")} disabled={disabled} className="w-full" data-testid="company-notas-per-page-select">
            {PER_PAGE.map((n) => <option key={n} value={n}>{n} nota</option>)}
          </NativeSelect>
        </Field>
        <Field label="Cadangan Estimasi (%)"><Input type="number" min={0} value={f.reserve_pct} onChange={set("reserve_pct")} disabled={disabled} data-testid="company-reserve-input" /></Field>
        <Field label="Pembulatan Invoice (kelipatan)"><Input type="number" min={1} value={f.round_multiple} onChange={set("round_multiple")} disabled={disabled} data-testid="company-round-input" /></Field>
      </div>
      <Field label="Catatan Kaki Nota"><Textarea rows={2} value={f.nota_footer || ""} onChange={set("nota_footer")} disabled={disabled} data-testid="company-footer-input" /></Field>
      {children}
      {!disabled && <Button type="submit" className="bg-emerald-700 hover:bg-emerald-800" data-testid="company-form-submit">{submitLabel}</Button>}
    </form>
  );
}
